// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__onH11","has-error":"logo_has-error__iwW3n"};